import ThemedComponent from '@hoc/ThemedComponent';

import { default as FlowFormViewDefault } from './FlowForm/View';
import { default as FlowFormView3 } from '@themes/3/components/Flows/FlowForm';
import { default as FlowFormView4 } from '@themes/4/components/FlowForm/FlowForm';

import { default as FlowSubAccountViewDefault } from './FlowSubAccount/View';
import { default as FlowSubAccontView4 } from '@themes/4/components/Flow/FlowSubAccount';

const ThemedFlowFlow = {
  default: FlowFormViewDefault,
  // 3: FlowFormView3,
  // 4: FlowFormView4,
};

const ThemedFlowSubAccount = {
  default: FlowSubAccountViewDefault,
  // 4: FlowSubAccontView4,
};

export const FlowFormView = ThemedComponent(ThemedFlowFlow);

export const FlowSubAccountView = ThemedComponent(ThemedFlowSubAccount);
